<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div
        class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText"
      >
        <el-row :gutter="24">
          <el-form
            ref="companyForm"
            :model="formData"
            :rules="rules"
            label-width="100px"
          >
            <el-col :span="16">
              <el-form-item
                v-for="(item, index) in formList"
                :key="index"
                :label="item.label"
                :prop="item.props"
                :rules="[
                  {
                    required: item.required,
                    message: '请输入' + item.label,
                    trigger: 'blur',
                  },
                ]"
              >
                <template v-if="item.type == 'input'">
                  <el-input v-model="formData[item.props]"></el-input>
                </template>
                <template v-else-if="item.type == 'textarea'">
                  <el-input
                    type="textarea"
                    v-model="formData[item.props]"
                  ></el-input>
                </template>
                <template v-else-if="item.type == 'picker'">
                  <el-select
                    v-model="formData[item.props]"
                    placeholder="请选择"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="(item1, index1) in item.selectOption"
                      :key="index1"
                      :label="item1.label"
                      :value="item1.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else-if="item.type == 'multiplePicker'">
                  <el-select
                    v-model="formData[item.props]"
                    placeholder="请选择"
                    clearable
                    filterable
                    multiple
                  >
                    <el-option
                      v-for="(item1, index1) in item.selectOption"
                      :key="index1"
                      :label="item1.label"
                      :value="item1.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else-if="item.type == 'cascader'">
                  <el-cascader
                    v-model="formData[item.props]"
                    placeholder="请选择"
                    clearable
                    filterable
                    :checkStrictly="true"
                    :show-all-levels="false"
                    :props="{ multiple: item.multiple }"
                    :options="item.selectOption"
                  >
                  </el-cascader>
                </template>
              </el-form-item>
              <el-form-item>
                <div>
                  <el-button
                    size="medium"
                    type="primary"
                    :disabled="loadingStaus"
                    @click="saveConfirm"
                    >保存</el-button
                  >
                  <el-button size="medium" @click="returnList">返回</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import UploadFile from "@/components/UploadFile";
import { mapGetters } from "vuex";
import json from "../../../public/citys.json";
import { gettreeList } from "@/utils/utils";

export default {
  components: {
    PageHeaderLayout,
    UploadFile,
  },
  data() {
    return {
      json,
      formList: [
        {
          required: true,
          label: "岗位名称",
          type: "input",
          props: "recruit_post",
          value: "",
          placeholder: "请输入岗位名称",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位标签",
          type: "multiplePicker",
          props: "tag_arr",
          value: [],
          selectOption: [],
          placeholder: "请选择岗位标签",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "industry_type_arr",
          value: [],
          multiple: true,
          selectOption: [],
          placeholder: "请选择行业类型",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工企业",
          type: "input",
          props: "company_name",
          value: [],
          placeholder: "请输入用工企业",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "worked_num",
          value: "",
          placeholder: "请输入用工人数",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "最小年龄",
          type: "input",
          props: "min_age",
          value: "",
          placeholder: "请输入最小年龄",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "最大年龄",
          type: "input",
          props: "max_age",
          value: "",
          placeholder: "请输入最大年龄",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "学历要求",
          type: "picker",
          props: "education",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: 1 },
            { label: "初中", value: 2 },
            { label: "高中", value: 3 },
            { label: "大专", value: 4 },
            { label: "本科及以上", value: 5 },
          ],
          placeholder: "请选择学历要求",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作地点",
          type: "cascader",
          props: "work_city",
          value_text_props: "address",
          value: "",
          selectOption: json.data,
          valueLevel: "more",
          placeholder: "请选择工作地点",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "详细地点",
          type: "input",
          props: "address_detail",
          placeholder: "请输入详细地点",
          value: "",
          disabled: false,
          show: true,
        },
        {
          label: "联系人",
          type: "input",
          props: "contact",
          placeholder: "请输入联系人",
          value: "",
          disabled: false,
          show: true,
        },
        {
          label: "联系人电话",
          type: "input",
          props: "contact_number",
          placeholder: "请输入联系人电话",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "最低薪资",
          type: "input",
          props: "min_salary",
          placeholder: "请输入最低薪资",
          value: "",
          show: true,
        },
        {
          required: true,
          label: "最高薪资",
          type: "input",
          props: "max_salary",
          placeholder: "请输入最高薪资",
          value: "",
          show: true,
        },

        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: [
            { label: "日结", value: 1 },
            { label: "周结", value: 2 },
            { label: "月结", value: 3 },
            { label: "次结", value: 4 },
            { label: "完工结", value: 5 },
          ],
          placeholder: "请选择结算方式",

          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位状态",
          type: "picker",
          props: "show_status",
          placeholder: "请选择岗位状态",
          selectOption: [
            { label: "未开始", value: 0 },
            { label: "进行中", value: 1 },
            { label: "已完成", value: 2 },
            { label: "已暂停", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作性质",
          type: "picker",
          props: "work_type",
          placeholder: "请选择工作性质",
          value_text_props: "work_type_name",
          selectOption: [
            { label: "全职", value: 1 },
            { label: "兼职", value: 2 },
            { label: "实习", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        {
          label: "职位介绍",
          type: "textarea",
          props: "job_remark",
          placeholder: "请输入职位介绍",
          value: "",
          disabled: false,
          show: true,
        },
      ],
      dialogVisible: false,
      activeTab: "0",
      hearTitle: "基本设置",
      loadingStaus: true,
      loadingText: "正在提交中……",
      formDisabled: false,
      billId: 0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      // 分类列表
      categoryList: [],
      openapiList: [],
      // 标签
      categoryLabelList: [],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList: [],
      // 已选中标签
      selectedLabelList: [],
      // 公司基本信息表单结构
      formData: {
      },
      // 已上传图片列表
      uploadFileList: [],
      // 公司基本信息规则
      rules: {
        name: [{ required: true, message: "输入公司名称", trigger: "blur" }],
        file_url: [
          { required: true, message: "输入文件名称", trigger: "blur" },
        ],
      },
      // 附件类型
      attachmentType: [
        "application/pdf",
        "application/caj",
        "",
        "application/zip",
        "application/rar",
        "application/doc",
      ],
      // 已上传附件列表
      attachmentUploadFileList: [],
      imageUrl: "", //图片地址
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    async getDailyTaskIndustryList() {
      let res = await this.$api.getDailyTaskIndustryList();
      this.formList[2].selectOption = gettreeList(
        res,
        "industry_type_name",
        "id"
      );
    },
    async getDailyPostTagList() {
      let res = await this.$api.getDailyPostTagList();
      this.formList[1].selectOption = gettreeList(res, "name", "id");
    },
    // 返回列表
    returnList() {
      this.$router.push("/position");
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v);
      if (v) {
        this.formData.parent_id = v;
      }
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs["companyForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true;
      console.log("formData -> ", this.formData);
      try {
        let param = {};
        if (this.formData.work_city[0]) {
          param = {
            province: this.formData.work_city[0],
            city: this.formData.work_city[1],
            area: this.formData.work_city[2],
          };
          delete this.formData.work_city;
        }
        let cate_arr = []
        if (Array.isArray(this.formData.industry_type_arr[0])) {
          this.formData.industry_type_arr.map((item) => {
            cate_arr.push(item[item.length - 1]);
          });
          this.formData.industry_type_arr = cate_arr;
        }
        let res;
        if(this.id){
          res = await this.$api.updateDailyPost({
          ...this.formData,
          ...param,
          id:this.id
        });
        }else{
          res = await this.$api.createDailyPost({
          ...this.formData,
          ...param,
        });
        }
        if (res) {
          this.$notify.success("保存成功！");
          this.returnList();
        }
        this.$nextTick(() => {
          this.loadingStaus = false;
        });
      } catch (err) {
        console.log("err is ->", err);
      }
    },
    // 初始化公司基本信息
    async init() {
      this.formDisabled = this.$route.query.type === "details" ? true : false;
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      if (this.id) {
        let data = await this.$api.getDailyPostInfo({id:this.id});
        this.formData = data;
        this.formData.tag_arr = data.recruit_tag.map(item=>item.tag_id)
        this.formData.industry_type_arr = data.recruit_industry.map(item=>[item.pid,item.industry_type])
        console.log(this.formData.industry_type_arr,99999)
        this.formData.work_city = [data.province,data.city,data.area]

      }
    },
  },
  async mounted() {
    this.loadingStaus = true;
    this.init();
    this.getDailyTaskIndustryList();
    this.getDailyPostTagList();
    this.$nextTick(() => {
      this.loadingStaus = false;
    });
  },
};
</script>

<style lang="stylus" scoped>
.content-left
  min-height 640px
  border-right 1px solid  #e8e8e8
  .el-cascader
    display block
    width 320px
.back-btn
  position absolute;
  right 50px;
  top 150px;
.content-right
  .right-button
    border-top 1px solid #e8e8e8e8
    padding 12px 12px
  .el-form-item__label
    float none
    display inline-block
    text-align left
    padding 0 0 10px 0
  .el-form-item__content
    margin-left 0px !important
    .el-checkbox-group
      margin-top -12px
.preview
  width: 100%
.idImg
  width: 100px
  cursor: pointer
</style>
